import React from 'react';
import AuthService from '../authService.js';
import GroupMemberItem from '../../Domain/UserGroup/GroupMemberItem.js';

export default class GroupHierarchyService extends React.Component {
  static AddGroupChieldren(item) {
    const url = '/api/UserGroup/AddGroupChieldren';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPost(url, item);
  }

  static RemoveGroupChildren(childrenIds, groupId) {
    const childrenIdsParam = childrenIds.join(',');
    const url = `/api/UserGroup/RemoveGroupChildren?groupId=${encodeURIComponent(
      groupId
    )}&childrenIds=${encodeURIComponent(childrenIdsParam)}`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionDelete(url);
  }
}
